import { authApi, formData } from "utils";

//PRODUCTS
export const getProductListAction = () => () => authApi.get("/self/products");

// FEEDBACKS
export const getFeedbackListAction = () => () => authApi.get("/self/feedback");

// QUERIES
export const getQueriesAction = () => () => authApi.get("/self/queries");

// THEMES
export const getThemesAction = shopId => () => authApi.get(`${shopId}/themes`, { timeout: 120000 });

// INVOICES
export const getInvoiceListAction = () => () => authApi.get("/self/invoices");

export const getDefaultThemesAction = () => () => authApi.get("/themes");

export const getThemeByIdAction = (shopId, themeId) => () => authApi.get(`${shopId}/themes/${themeId}`);



export const createThemeAction = ({ shopId, id }) => () => authApi.post(`${shopId}/themes`, formData({ id }));

export const createJobAction = ({ id }) => () => authApi.get(`/themes/jobs/create/${id}`);


export const duplicateThemeAction = ({ shopId, id }) => () => authApi.post(`${shopId}/themes/${id}/duplicate`, formData({}));

export const duplicateJobAction = ({ id }) => () => authApi.get(`/themes/jobs/duplicate/${id}`);


export const updateThemeAction = ({ shopId, themeId, ...rest }) => () => authApi.post(`${shopId}/themes/${themeId}`, formData(rest));

export const upgradeJobAction = ({ id }) => () => authApi.get(`/themes/jobs/update/${id}`);



export const resolveConflictThemeAction = ({ shopId, themeId, conflictId, ...rest }) => () => authApi.post(`${shopId}/themes/${themeId}/conflicts/${conflictId}/resolve`, formData(rest));

export const finishResolvingConflictsThemeAction = ({ shopId, themeId, ...rest }) => () => authApi.post(`${shopId}/themes/${themeId}/resolve-all-conflicts`, formData(rest));

export const upgradeThemeAction = ({ shopId, themeId, merge_type = "" }) => () => authApi.post(`${shopId}/themes/${themeId}/update`, formData({ merge_type }), { timeout: 120000 });

export const getConflictsThemeAction = ({ shopId, themeId }) => () => authApi.get(`${shopId}/themes/${themeId}/conflicts`);

export const deleteThemeAction = ({ themeId, shopId }) => () =>  authApi.post(`${shopId}/themes/${themeId}/delete`);

export const importThemeAction = ({ shopId, ...rest }) => () => authApi.post(`${shopId}/themes/import`, formData(rest));

export const exportThemeAction = ({ themeId, shopId }) => () => {
      return authApi.request({
        url: `${shopId}/themes/${themeId}/export`,
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const href = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `paylixecommerce.theme.${themeId}-${Date.now()}.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    };
// END THEMES

// TEMPLATES
export const getThemeTemplatesAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({type: "templates", shopId, themeId});

export const getThemeTemplateByIdAction = ({ shopId, themeId, templateId }) => () => getThemeEntityById({ type: "templates", entityId: templateId, shopId, themeId });

export const getTemplateTypesAction = shopId => () => authApi.get(`${shopId}/themes/templates/types`);

export const createThemeTemplateAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "templates", shopId, themeId, ...rest });

export const updateThemeTemplateAction = ({ shopId, themeId, templateId, ...rest }) => () => updateThemeEntityById({ type: "templates", shopId, themeId, entityId: templateId, ...rest });

export const deleteThemeTemplateAction = ({ shopId, themeId, templateId }) => () => deleteThemeEntityById({ type: "templates", shopId, themeId, entityId: templateId });
// END TEMPLATES

// SECTIONS
export const getThemeSectionsAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({type: "sections", shopId, themeId });

export const getThemeSectionIdAction = ({ shopId, themeId, sectionId }) => () => getThemeEntityById({ type: "sections", entityId: sectionId, shopId, themeId });

export const createThemeSectionAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "sections", shopId, themeId, ...rest });

export const updateThemeSectionAction = ({ shopId, themeId, sectionId, ...rest }) => () => updateThemeEntityById({ type: "sections", shopId, themeId, entityId: sectionId, ...rest });

export const deleteThemeSectionAction = ({ shopId, themeId, sectionId }) => () => deleteThemeEntityById({type: "sections", shopId, themeId, entityId: sectionId });
// END SECTIONS

// LAYOUTS
export const getThemeLayoutsAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({type: "layouts", shopId, themeId });

export const getThemeLayoutAction = ({ shopId, themeId, layoutId }) => () => getThemeEntityById({ type: "layouts", entityId: layoutId, shopId, themeId });

export const createThemeLayoutAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "layouts", shopId, themeId, ...rest });

export const updateThemeLayoutAction = ({ shopId, themeId, layoutId, ...rest }) => () => updateThemeEntityById({ type: "layouts", shopId, themeId, entityId: layoutId, ...rest });

export const deleteThemeLayoutAction = ({ shopId, themeId, layoutId }) => () => deleteThemeEntityById({ type: "layouts", shopId, themeId, entityId: layoutId });
// END LAYOUTS

// BLOCKS
export const getThemeBlocksAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({ type: "blocks", shopId, themeId });

export const getThemeBlockAction = ({ shopId, themeId, blockId }) => () => getThemeEntityById({ type: "blocks", entityId: blockId, shopId, themeId });

export const createThemeBlockAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "blocks", shopId, themeId, ...rest });

export const updateThemeBlockAction = ({ shopId, themeId, blockId, ...rest }) => () => updateThemeEntityById({type: "blocks", shopId, themeId, entityId: blockId, ...rest });

export const deleteThemeBlockAction = ({ shopId, themeId, blockId }) => () => deleteThemeEntityById({ type: "blocks", shopId, themeId, entityId: blockId });
// END BLOCKS

// ASSETS
export const getThemeAssetsAction = ({ shopId, themeId }) => () =>getThemeEntitiesByType({ type: "assets", shopId, themeId });

export const getThemeAssetAction = ({ shopId, themeId, assetId }) => () =>getThemeEntityById({ type: "assets", entityId: assetId, shopId, themeId });

export const createThemeAssetAction = ({ shopId, themeId, ...rest }) => () =>createThemeEntity({ type: "assets", shopId, themeId, ...rest });

export const updateThemeAssetAction = ({ shopId, themeId, assetId, ...rest }) => () => updateThemeEntityById({type: "assets", shopId, themeId, entityId: assetId, ...rest });

export const deleteThemeAssetAction = ({ shopId, themeId, assetId }) => () => deleteThemeEntityById({ type: "assets", shopId, themeId, entityId: assetId });
// END ASSETS

// FILES
export const getThemeFilesAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({ type: "files", shopId, themeId });

export const getThemeFileAction = ({ shopId, themeId, fileId }) => () => getThemeEntityById({ type: "files", entityId: fileId, shopId, themeId });

export const getThemeFileContentAction = ({ shopId, themeId, fileId }) => () => authApi.get(`${shopId}/themes/${themeId}/files/${fileId}/content`);

export const createThemeFileAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "files", shopId, themeId, ...rest });

export const updateThemeFileAction = ({ shopId, themeId, fileId, ...rest }) => () => updateThemeEntityById({ type: "files", shopId, themeId, entityId: fileId, ...rest});

export const deleteThemeFileAction = ({ shopId, themeId, fileId }) => () => deleteThemeEntityById({ type: "files", shopId, themeId, entityId: fileId });
// END FILES

// LOCALES
export const getThemeLocalesAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({ type: "locales", shopId, themeId });

export const getThemeLocaleAction = ({ shopId, themeId, localeId }) => () => getThemeEntityById({ type: "locales", entityId: localeId, shopId, themeId });

export const createThemeLocaleAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "locales", shopId, themeId, ...rest });

export const updateThemeLocaleAction = ({ shopId, themeId, localeId, ...rest }) => () => updateThemeEntityById({ type: "locales", shopId, themeId, entityId: localeId, ...rest });

export const deleteThemeLocaleAction = ({ shopId, themeId, localeId }) => () => deleteThemeEntityById({ type: "locales", shopId, themeId, entityId: localeId });
// END LOCALES

// SNIPPETS
export const getThemeSnippetsAction = ({ shopId, themeId }) => () => getThemeEntitiesByType({ type: "snippets", shopId, themeId });

export const getThemeSnippetAction = ({ shopId, themeId, snippetId }) => () => getThemeEntityById({type: "snippets", entityId: snippetId, shopId, themeId });

export const createThemeSnippetAction = ({ shopId, themeId, ...rest }) => () => createThemeEntity({ type: "snippets", shopId, themeId, ...rest });

export const updateThemeSnippetAction = ({ shopId, themeId, snippetId, ...rest }) => () => updateThemeEntityById({ type: "snippets", shopId, themeId, entityId: snippetId, ...rest });

export const deleteThemeSnippetAction = ({ shopId, themeId, snippetId }) =>  () => deleteThemeEntityById({ type: "snippets", shopId, themeId, entityId: snippetId });
// END SNIPPETS

export const getThemeEntitiesByType = ({ type, shopId, themeId }) => authApi.get(`${shopId}/themes/${themeId}/${type}`);

export const getThemeEntityById = ({ type, themeId, entityId, shopId }) => authApi.get(`${shopId}/themes/${themeId}/${type}/${entityId}`);

export const createThemeEntity = ({ type, themeId, shopId, ...rest }) => authApi.post(`${shopId}/themes/${themeId}/${type}`, formData(rest));

export const updateThemeEntityById = ({ type, themeId, shopId, entityId, ...rest }) =>  authApi.post(`${shopId}/themes/${themeId}/${type}/${entityId}`, formData(rest));

export const deleteThemeEntityById = ({ type, themeId, shopId, entityId }) => authApi.post(`${shopId}/themes/${themeId}/${type}/${entityId}/delete`);

// PAGES
export const getPagesAction = shopId => () => authApi.get(`${shopId}/themes/pages`);
// END PAGES

// MENUS
export const getMenusAction = shopId => () => authApi.get(`${shopId}/themes/menus`);
// END MENUS

// LIBRARY
export const getThemesLibraryAction = () => () => authApi.get(`themes/library`);
// END LIBRARY
